<template>
    <div v-if="isVisible" @click.stop="handleClick" class="widget-wrapper" :style="wrapperStyle">
        <div class="widget-container" :style="containerStyle">
            <WidgetClose @close="handleClose" v-if="isModal()" />
            <div class="widget-content" :style="contentStyle">
                <slot style="pointer-events: all"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { resolveBorder, resolveMargin, resolvePadding, resolveShadow } from "./utils/style"
import WidgetClose from "./WidgetClose.vue"

export default {
    components: { WidgetClose },
    props: {
        settings: {
            type: Object,
            default: () => {}
        }
    },
    name: "WidgetWrapper",
    data() {
        return {
            isVisible: true
        }
    },
    mounted() {
        this.getHandlers()
    },
    methods: {
        getHandlers() {
            if (this.isModal() && !this.isDevMode()) {
                this.isVisible = false
                const params = new URL(import.meta.url).searchParams
                if (!params) {
                    return
                }
                const timestamp = params.get("t")

                const handlers = document.querySelectorAll(`[data-widget-handler='${timestamp}']`)

                for (const handler of handlers) {
                    handler.addEventListener("click", () => {
                        this.isVisible = true

                        setTimeout(() => {
                            const firstInput = document.querySelector(
                                '.widget-wrapper .custom-block input:not([tabindex="-1"]), .widget-wrapper .custom-block textarea:not([tabindex="-1"])'
                            )
                            if (firstInput) {
                                firstInput.focus()
                            }
                        }, 300)

                        if (import.meta?.url) {
                            for (const attribute of handler.attributes) {
                                if (attribute.nodeName.includes("utm")) {
                                    import.meta[attribute.nodeName] = [attribute.nodeValue]
                                }
                            }
                        }
                    })
                }

                if (!handlers.length) {
                    console.error(`No Kwiga modal handlers found: [data-widget-handler='${timestamp}']`)
                    setTimeout(() => this.getHandlers(), 2000)
                }
            }
        },
        handleClick(ev) {
            if (!this.hasClickOutside) {
                return
            }

            if (ev.target && ev.target.classList && ev.target.classList.contains("widget-wrapper")) {
                this.isVisible = false
            }
        },
        handleClose() {
            if (this.isDevMode()) {
                console.log("close")
            } else {
                this.isVisible = false
            }
        },
        isDevMode() {
            return window.builder_dev_mode
        },
        isModal() {
            return this.modal && this.modal.isModal
        },
        flex() {
            return {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
            }
        }
    },
    computed: {
        modal() {
            return this.settings && this.settings.general && this.settings.general.modal
        },
        contentStyle() {
            return {
                pointerEvents: "none",
                ...this.flex(),
                maxWidth: "100%",
                width: "100%"
            }
        },
        hasClickOutside() {
            if (this.isDevMode()) {
                return false
            }

            return this.isModal()

            // eslint-disable-next-line no-unreachable
            if (!import.meta?.url) {
                return false
            }

            const params = new URL(import.meta.url).searchParams

            if (!params) {
                return false
            }

            const uuid = params.get("uuid")

            return uuid === "e8a8673a-61a6-4b8a-8da3-96115365dbf1"
        },
        containerStyle() {
            let style = {
                pointerEvents: "none",
                ...this.flex()
            }

            if (this.isModal()) {
                style = {
                    ...style,
                    background: this.modal.background,
                    ...resolvePadding(this.modal.padding),
                    ...resolveMargin(this.modal.margin),
                    maxWidth: "calc(100% - 3%)",
                    animation: ".3s ease 0s 1 widget-up"
                }

                if (this.modal.shadow.hasShadow) {
                    style = {
                        ...style,
                        ...resolveShadow(this.modal.shadow)
                    }
                }

                if (this.modal.border) {
                    style = {
                        ...style,
                        ...resolveBorder(this.modal.border)
                    }
                }

                style = {
                    ...style,
                    borderRadius: `${this.modal.borderRadius}px`
                }
            }

            return style
        },
        wrapperStyle() {
            let style = {
                pointerEvents: this.hasClickOutside ? "all" : "none",
                width: "100%"
            }

            if (this.isModal()) {
                if (this.isDevMode()) {
                    const container = document.querySelector(".widget-view-container")
                    if (container) {
                        // eslint-disable-next-line no-unused-vars
                        const { height } = container.getBoundingClientRect()

                        style = {
                            ...style,
                            position: "static",
                            width: "100%",
                            zIndex: 99999,
                            background: this.modal.overlay.background,
                            ...this.flex()
                        }

                        /*if (this.modal.overlay.isBlured) {
                            style.backdropFilter = "blur(6px)"
                        }*/
                    }
                } else {
                    style = {
                        ...style,
                        position: "fixed",
                        width: "100vw",
                        height: `100vh`,
                        zIndex: 99999,
                        background: this.modal.overlay.background,
                        top: 0,
                        left: 0,
                        ...this.flex(),
                        justifyContent: "safe center",
                        maxHeight: `100vh`,
                        overflow: "auto",
                        pointerEvents: "all"
                    }

                    if (this.modal.overlay.isBlured) {
                        style.animation = ".1s ease 0s 1 widget-blur forwards"
                    }
                }
            }

            return style
        }
    }
}
</script>
